<template>
  <b-modal
    :title="'Venda #' + order.number"
    v-model="modal"
    scrollable
    size="lg"
  >
    <b-container>
      <b-row>
        <b-col>
          <h5 class="text-muted">
            <i class="fas fa-user mr-1" /> {{ client_name }}
          </h5>
        </b-col>
      </b-row>
      <div class="pt-0 ml-4" v-if="order.client_id != null">
        <b-row v-if="person.phone_wa != null" class="m-1">
          <small class="text-muted">
            <i class="fab fa-whatsapp mr-1" />
            {{ person.phone_wa | VMask("(##) # ####-####") }}
          </small>
        </b-row>
        <b-row v-if="person.phone2 != null" class="m-1">
          <small class="text-muted">
            <i class="fas fa-phone-alt mr-1" />
            {{ person.phone2 | VMask("(##) ####-####") }}
          </small>
        </b-row>
        <b-row v-if="person.email1 != null" class="m-1">
          <small class="text-muted">
            <i class="far fa-envelope mr-1" /> {{ person.email1 }}
          </small>
        </b-row>
        <b-row v-if="person.address != null" class="m-1">
          <small class="text-muted">
            <i class="fas fa-map-marker-alt mr-1" /> {{ address.address }},
            {{ address.district }}, {{ address.state }}-{{ address.zipcode }}
          </small>
        </b-row>
      </div>
      <div v-if="salesman != null">
        <hr class="ml-4" />
        <b-row>
          <b-col>
            <span class="text-muted">
              <i class="fas fa-user-tie mr-1" /> Vendedor: {{ salesman.name }}
            </span>
            <br />
            <small class="text-muted ml-4">
              Comissão: {{ order.comission_rate | decimal }}%
            </small>
          </b-col>
        </b-row>
      </div>
      <hr v-if="order.client_id != null || salesman != null" />
      <order-view-list :products="products" class="ml-3 mr-3" />
      <hr class="ml-4" />
      <b-row align-h="between">
        <b-col>
          <h5>Total</h5>
        </b-col>
        <b-col>
          <h5 class="text-right">R$ {{ order.net_total | decimal }}</h5>
        </b-col>
      </b-row>
      <b-row v-if="this.$acl.isAdmin()" class="text-muted">
        <b-col>
          <small>Margem de ganho</small>
        </b-col>
        <b-col class="text-right">
          <small>{{ order.profit | moneyBr }}</small>
        </b-col>
      </b-row>
      <hr />

      <b-row class="ml-1" align-h="between">
        <b-col>
          <template v-for="row in orderBills">
            <div
              class="row grid-table-row d-flex justify-content-between p-1"
              :key="row.id"
            >
              <div class="order-1 order-md-1 align-middle pt-2 p-0 text-right">
                <i :class="setIcon(row)" /> {{ setPaymentMethod(row) }}
                <b-badge class="ml-2" v-if="row.payment_method == 5">{{
                  row.due_date | dateBr
                }}</b-badge>
              </div>
              <div class="order-2 order-md-2 align-middle mr-3 p-0 text-right">
                R$ {{ row.value | decimal }}
              </div>
            </div>
          </template>
        </b-col>
      </b-row>
      <template v-if="order.notes">
        <hr />
        <b-row class="d-flex flex-column ml-1">
          <h5>Observações</h5>
          <b-col>
            {{ order.notes }}
          </b-col>
        </b-row>
      </template>
    </b-container>
    <template #modal-footer>
      <button
        role="button"
        class="btn btn-outline-secondary"
        @click="modal = false"
        tabindex="-1"
      >
        Voltar
      </button>
    </template>
  </b-modal>
</template>

<script>
import OrderViewList from "../lists/OrderViewList";
export default {
  components: {
    OrderViewList,
  },
  props: {},

  data: function () {
    return {
      order: {},
      person: {},
      address: {},
      salesman: {},
      products: {},
      modal: false,
      orderBills: {},
      client_name: null,
      payment_method: {},

      operations: {
        1: {
          path: "venda",
        },

        2: {
          path: "devolucao",
        },
      },
    };
  },

  computed: {},

  methods: {
    open(id) {
      axios
        .get(process.env.BASE_URL + "erp/order/order/" + id)
        .then((response) => {
          this.modal = true;
          this.products = response.data.orderProducts;
          this.order = response.data.order;
          this.orderBills = response.data.orderBills;
          this.person = response.data.person;
          this.address = response.data.address;
          this.salesman = response.data.salesman;
          this.setClient();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    printOrder() {
      window.open("/vendas/imprimir/cupom/" + this.order.id, "_blank");
    },

    editOrder() {
      this.$router.push(
        "/vendas/" +
          this.operations[this.order.operation_id].path +
          "/editar/" +
          this.order.id
      );
    },

    setPaymentMethod(row) {
      if (row.payment_method == 1) {
        return "Dinheiro";
      }

      if (row.payment_method == 2) {
        return "Cheque";
      }

      if (row.payment_method == 3) {
        return "Cartão de Credito";
      }

      if (row.payment_method == 4) {
        return "Cartão de Débito";
      }

      if (row.payment_method == 5) {
        return " Credito Loja ";
      }

      if (row.payment_method == 15) {
        return "Boleto Bancário";
      }

      if (row.payment_method == 16) {
        return "Depósito Bancário";
      }

      if (row.payment_method == 17) {
        return "Pix";
      }
      if (row.payment_method == 18) {
        return "Carteira Digital ";
      }
      if (row.payment_method == 99) {
        return "Outros ";
      }
    },

    setIcon(row) {
      if (row.payment_method == 1) {
        return "fas fa-money-bill ml-1";
      }

      if (row.payment_method == 2) {
        return "fas fa-money-check ml-1";
      }

      if (row.payment_method == 3) {
        return "far fa-credit-card ml-1";
      }

      if (row.payment_method == 4) {
        return "fas fa-credit-card ml-1";
      }

      if (row.payment_method == 5) {
        return "fas fa-file-invoice-dollar ml-1";
      }
      if (row.payment_method == 15) {
        return "fas fa-file-invoice-dollar ml-1";
      }
      if (row.payment_method == 16) {
        return "fas fa-file-invoice-dollar ml-1";
      }
      if (row.payment_method == 17) {
        return "fa fa-qrcode ml-1";
      }
      if (row.payment_method == 18) {
        return "fa fa-qrcode ml-1";
      }
      if (row.payment_method == 99) {
        return "fas fa-money-check-alt ml-1";
      }
    },

    setClient() {
      if (this.order.client_id == null) {
        this.client_name = "Consumidor Final";
      }

      if (this.order.client_id != null) {
        this.client_name = this.person.name;
      }
    },
  },
};
</script>

<style>
</style>
